import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { AppDispatch, RootState } from "../../state/store";
import { useAppDispatch } from "../../state/hooks";
import { useSignalRContext } from "../Contexts/SignalRContext";
import { loadSessionInfo } from "../../state/actions/authActions";

function refreshUserInfo(dispatch: AppDispatch) {
  dispatch(loadSessionInfo()).catch(() => {
    // Offline, the stored user is the best available.
  });
}

export default function UserInfoRefreshListener() {
  const dispatch = useAppDispatch();
  const { connection, isReconnecting } = useSignalRContext();
  const isAuthenticated = useSelector((s: RootState) => s.authReducer.isAuthenticated);
  const [isRestoredSession] = useState(isAuthenticated);
  const isHubLive = !!connection && !isReconnecting;
  const hubWasLive = useRef(false);

  useEffect(() => {
    if (isRestoredSession) refreshUserInfo(dispatch);
  }, [dispatch, isRestoredSession]);

  useEffect(() => {
    if (!isAuthenticated) {
      hubWasLive.current = false;
      return;
    }
    if (!isHubLive) return;

    if (hubWasLive.current) refreshUserInfo(dispatch);
    hubWasLive.current = true;
  }, [dispatch, isAuthenticated, isHubLive]);

  useEffect(() => {
    if (!connection || !isAuthenticated) return;

    const handleUserInfoChanged = () => refreshUserInfo(dispatch);

    connection.on("UserInfoChangedAsync", handleUserInfoChanged);

    return () => {
      connection.off("UserInfoChangedAsync", handleUserInfoChanged);
    };
  }, [connection, dispatch, isAuthenticated]);

  return null;
}
